import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=c5fa99c0&scoped=true&lang=pug&"
import script from "./Cookies.vue?vue&type=script&lang=ts&"
export * from "./Cookies.vue?vue&type=script&lang=ts&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=c5fa99c0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fa99c0",
  null
  
)

export default component.exports